import { SyncStatusStoreModel } from "@bitwarden/web-vault/app/models/store/sync-status.store.model";

type SyncStatusStoreModel2 = Omit<SyncStatusStoreModel, "v" | "err"> & {
  v: 2;
  err: null;
};

export const sync_status_v1_to_v2 = (syncStatus: SyncStatusStoreModel): SyncStatusStoreModel2 => {
  return {
    ...syncStatus,
    err: null,
    v: 2,
  };
};
